import api from 'api/axios';

export const getEclinicDoctors = async (params) => {
  return api.get("/admin/eclinic/doctors", {
    params,
  });
};

export const getEclinicDoctorById = async (id) => {
  return api.get(`/admin/eclinic/${id}`);
};

export const approveDoctor = async (id, payload) => {
  return api.patch(`/admin/eclinic/approve/${id}`, payload);
};

export const rejectDoctor = async (id, payload) => {
  return api.patch(`/admin/eclinic/reject/${id}`, {
    adminRemarks: payload?.remarks
  });
};

export const getEclinicStats = async () => {
  return api.get("/admin/eclinic/stats");
};
